import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import TestimonialsHeroSection from './components/TestimonialsHeroSection';
import PatientStoriesSection from './components/PatientStoriesSection';
import SuccessMetricsSection from './components/SuccessMetricsSection';
import TestimonialsCTASection from './components/TestimonialsCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/testimonials#webpage`,
      url: `${siteUrl}/testimonials`,
      name: 'Testimonials | Real Stories of Oxygen Health Impact – Diatomic Life Foundation',
      description:
        "Read real stories from families and patients whose lives have been transformed by Diatomic Life Foundation's oxygen supplementation and health programs.",
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Testimonials', item: `${siteUrl}/testimonials` },
        ],
      },
    },
    {
      '@type': 'ItemList',
      '@id': `${siteUrl}/testimonials#stories`,
      name: 'Patient Stories – Diatomic Life Foundation',
      description: 'Real testimonials from families and patients impacted by Diatomic Life Foundation oxygen health programs.',
      itemListElement: [
        {
          '@type': 'Review',
          position: 1,
          reviewBody: 'After using the OxyKit for three months, my father\'s energy levels improved dramatically. We are grateful to Diatomic Life Foundation.',
          author: { '@type': 'Person', name: 'Priya S., Mumbai' },
          itemReviewed: {
            '@type': 'NGO',
            '@id': `${siteUrl}/#organization`,
            name: 'Diatomic Life Foundation',
          },
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
        },
        {
          '@type': 'Review',
          position: 2,
          reviewBody: 'The OxyAI app detected my oxygen deficiency early. The foundation\'s support changed my life.',
          author: { '@type': 'Person', name: 'Ramesh K., Delhi' },
          itemReviewed: {
            '@type': 'NGO',
            '@id': `${siteUrl}/#organization`,
            name: 'Diatomic Life Foundation',
          },
          reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
        },
      ],
    },
  ],
};

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SEO
        title="Testimonials | Real Stories of Oxygen Health Impact – Diatomic Life Foundation"
        description="Hear from families and patients whose lives changed through Diatomic Life Foundation's oxygen supplementation, AI screening, and education programs. Real stories, real impact."
        keywords="oxygen health testimonials, patient stories, Diatomic Life Foundation reviews, oxygen supplementation results"
        canonical={`${siteUrl}/testimonials`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <TestimonialsHeroSection />
        <PatientStoriesSection />
        <SuccessMetricsSection />
        <TestimonialsCTASection />
      </main>
      <Footer />
    </div>
  );
}
